import m from "../../geodata/es2015/serbiaHigh";
window.am4geodata_serbiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/serbiaHigh.js
// module id = null
// module chunks = 